import axios, { AxiosError, AxiosResponse } from 'axios'
import { ICommonQuery } from '@Models/common.model'
import * as Redux from 'redux'
import { ToastServices } from '@Services/toast.service'
import { ClientActionTypes } from '@ClientStores/client.action-types'
import SharedActions from '@SharedActions/loading.action'
import { APIServices } from '@Services/api.service'
import { AuthActionTypes } from '@Stores/auth/auth.action-types'
import { MCity, MState } from '@Models/auth.model'

const INSURANCE = `${APIServices.apiUrlV1}/admin/insurances`

const getInsurances = (ExtraParams?: ICommonQuery) => {
    return (dispatch: Redux.Dispatch) => {
        APIServices.axiosConfig()
        dispatch(SharedActions.setClientLoading(true) as any)
        const params = {
            status: 'ACTIVE',
            ...ExtraParams,
        }
        axios
            .get(INSURANCE, { params })
            .then((response: AxiosResponse) => {
                const payload = response?.data
                const city = payload?.data?.[0]?.city
                const state = payload?.data?.[0]?.state

                dispatch({
                    type: AuthActionTypes.GET_STATES,
                    payload: state?.code ? [new MState(state)] : [],
                })

                dispatch({
                    type: AuthActionTypes.GET_CITIES,
                    payload: city?.code ? [new MCity(city)] : [],
                })

                dispatch({ type: ClientActionTypes.GET_INSURANCES, payload })
                dispatch(SharedActions.setClientLoading(false) as any)
            })
            .catch((errors: AxiosError) => {
                const message = errors?.response?.data?.message
                ToastServices.error(message || 'Unspecific errors!')
                dispatch(SharedActions.setClientLoading(false) as any)
            })
    }
}

const addInsurance = (payload: any) => {
    return (dispatch: Redux.Dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch(SharedActions.setClientLoading(true) as any)
            axios
                .post(INSURANCE, payload)
                .then((response: AxiosResponse) => {
                    ToastServices.success('Insurance added')
                    dispatch(SharedActions.setClientLoading(false) as any)
                    resolve(response)
                })
                .catch((errors: AxiosError) => {
                    const message = errors?.response?.data?.message
                    ToastServices.error(message || 'Unspecific errors!')
                    dispatch(SharedActions.setClientLoading(false) as any)
                    reject(errors)
                })
        })
    }
}

const updateInsurance = (id: string, payload: any) => {
    return (dispatch: Redux.Dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch(SharedActions.setClientLoading(true) as any)
            axios
                .put(`${INSURANCE}/${id}`, payload)
                .then((response: AxiosResponse) => {
                    ToastServices.success('Insurance updated')
                    dispatch(SharedActions.setClientLoading(false) as any)
                    resolve(response)
                })
                .catch((errors: AxiosError) => {
                    const message = errors?.response?.data?.message
                    ToastServices.error(message || 'Unspecific errors!')
                    dispatch(SharedActions.setClientLoading(false) as any)
                    reject(errors)
                })
        })
    }
}

const ClientInsuranceActions = {
    getInsurances,
    addInsurance,
    updateInsurance,
}

export default ClientInsuranceActions
